module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-backplates.7ef0845b.png";